import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["picker", "text"]

  sync() {
    if (this.hasTextTarget) {
      this.textTarget.value = this.pickerTarget.value
    }
  }

  syncFromText() {
    const value = this.textTarget.value
    if (this.hasPickerTarget && /^#[0-9a-fA-F]{6}$/.test(value)) {
      this.pickerTarget.value = value
    }
  }
}
